import React, { useState } from 'react';
import { firestore } from '../firebaseConfig';
import { Lock, User } from 'lucide-react';
import CryptoJS from 'crypto-js';
import { useNavigate } from "react-router-dom";

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #e6f4eb 0%, #ffffff 100%)',
    padding: '20px',
  },
  card: {
    background: 'white',
    borderRadius: '24px',
    padding: '2rem',
    width: '100%',
    maxWidth: '400px',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
    animation: 'slideUp 0.5s ease-out',
  },
  logo: {
    width: '150px',
    height: 'auto',
    display: 'block',
    margin: '0 auto 2rem',
  },
  title: {
    textAlign: 'center',
    color: '#2d3748',
    fontSize: '1.8rem',
    fontWeight: '700',
    marginBottom: '2rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  inputGroup: {
    position: 'relative',
  },
  input: {
    width: '100%',
    padding: '1rem 1rem 1rem 3rem',
    fontSize: '1rem',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    outline: 'none',
    transition: 'all 0.3s ease',
    boxSizing: 'border-box',
  },
  icon: {
    position: 'absolute',
    left: '1rem',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#4a5568',
  },
  button: {
    background: '#33AE54',
    color: 'white',
    padding: '1rem',
    borderRadius: '12px',
    border: 'none',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginTop: '1rem',
  },
  error: {
    color: '#e53e3e',
    textAlign: 'center',
    marginTop: '1rem',
    padding: '0.75rem',
    background: 'rgba(229, 62, 62, 0.1)',
    borderRadius: '8px',
  },
};

function Login({  }) {
  const navigate = useNavigate();

  const [employeeId, setEmployeeId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const officersRef = firestore.collection('enforcement_officer');
      const snapshot = await officersRef
        .where('employeeId', '==', employeeId)
        .where('status', '==', 'active')
        .get();

      if (snapshot.empty) {
        throw new Error('Invalid credentials');
      }
      const passwordMatch = CryptoJS.AES.decrypt(snapshot.docs[0].data().password, 'ZEHkZJo6taM52FSiio1h4g==').toString(CryptoJS.enc.Utf8) === password;
      
      if (!passwordMatch) {
        throw new Error('Invalid credentials');
      }
      

      const officer = {
        id: snapshot.docs[0].id,
        ...snapshot.docs[0].data()
      };

      localStorage.setItem('user', CryptoJS.AES.encrypt(JSON.stringify(officer), 'ZEHkZJo6taM52FSiio1h4g==').toString());
      localStorage.setItem('loginTimestamp', Date.now().toString());
      navigate("/");
    } catch (err) {
      setError('Invalid employee ID or password');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img src="../assets/img/Logo.png" alt="ParkingPal Logo" style={styles.logo} />
        <h1 style={styles.title}>Enforcement Login</h1>
        
        <form style={styles.form} onSubmit={handleSubmit}>
          <div style={styles.inputGroup}>
            <User size={20} style={styles.icon} />
            <input
              type="text"
              placeholder="Employee ID"
              value={employeeId}
              onChange={(e) => setEmployeeId(e.target.value)}
              style={styles.input}
              required
            />
          </div>
          
          <div style={styles.inputGroup}>
            <Lock size={20} style={styles.icon} />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              required
            />
          </div>

          <button
            type="submit"
            style={{
              ...styles.button,
              opacity: isLoading ? 0.7 : 1,
              cursor: isLoading ? 'not-allowed' : 'pointer',
            }}
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
          
          {error && <div style={styles.error}>{error}</div>}
        </form>
      </div>
    </div>
  );
}

export default Login;